export function formatCpfCnpjDisplay(value) {
  if (value == null) return ''
  const str = String(value).trim()
  if (str === '') return ''
  const digits = str.replace(/\D/g, '')
  if (digits.length === 11) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  }
  if (digits.length === 14) {
    return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
  }
  return str
}

export function validarCpfCnpj(doc) {
  const d = String(doc || '').replace(/\D/g, '')
  if (d.length !== 11 && d.length !== 14) return false
  if (/^(\d)\1+$/.test(d)) return false

  if (d.length === 11) {
    let sum = 0
    for (let i = 0; i < 9; i++) sum += parseInt(d[i]) * (10 - i)
    let r = (sum * 10) % 11
    if (r === 10 || r === 11) r = 0
    if (r !== parseInt(d[9])) return false
    sum = 0
    for (let i = 0; i < 10; i++) sum += parseInt(d[i]) * (11 - i)
    r = (sum * 10) % 11
    if (r === 10 || r === 11) r = 0
    return r === parseInt(d[10])
  }

  const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  let sum = pesos1.reduce((acc, p, i) => acc + parseInt(d[i]) * p, 0)
  let r = sum % 11
  const d13 = r < 2 ? 0 : 11 - r
  if (d13 !== parseInt(d[12])) return false
  sum = pesos2.reduce((acc, p, i) => acc + parseInt(d[i]) * p, 0)
  r = sum % 11
  const d14 = r < 2 ? 0 : 11 - r
  return d14 === parseInt(d[13])
}
